import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { isNotEmpty, isNotNil } from 'ramda';

import { NULLISH_CELL_VALUE } from '~/components/DataGridCustom';
import { SourceReferenceLink, SourceReferenceLinks } from '~/components/SourceReferenceLinks/SourceReferenceLinks';

export interface SourceReferenceCellProps<R extends GridValidRowModel = any> {
  values?: SourceReferenceLink[];
  row?: R;
}

export const SourceReferenceCell = <R extends GridValidRowModel = any>({ values }: SourceReferenceCellProps<R>) => {
  return <>{isNotNil(values) && isNotEmpty(values) ? <SourceReferenceLinks values={values} /> : NULLISH_CELL_VALUE}</>;
};
